import { motion } from "motion/react";
import React from "react";
import { DYNAMIC_ISLAND } from "../../../../config/dynamicIsland.configuration";
import { DYNAMIC_ISLAND_INSTANT_TRANSITION } from "../../animation/dynamicIslandAnimation.types";

interface DynamicIslandItinerarySummaryMotionLegItemProps {

    /** Leg row index for enter stagger. */
    "index": number;

    /** Whether this leg chip is selected. */
    "isSelected": boolean;

    /** Whether motion is disabled (reduced motion or config). */
    "reducedMotion": boolean;

    /** Leg chip content from ItineraryDetailsSummary. */
    "children": React.ReactNode;
}

/**
 * Motion wrapper for a single itinerary summary leg chip in island layout.
 *
 * @param props Wrapper props.
 * @returns Staggered, layout-animated leg item.
 */
const DynamicIslandItinerarySummaryMotionLegItem: React.FC<DynamicIslandItinerarySummaryMotionLegItemProps> = ( {
    index,
    isSelected,
    reducedMotion,
    children,
} ) => {
    const animationsEnabled = DYNAMIC_ISLAND.animations.enabled && !reducedMotion;
    const transition = animationsEnabled
        ? DYNAMIC_ISLAND.animations.spring
        : DYNAMIC_ISLAND_INSTANT_TRANSITION;
    const staggerDelay = animationsEnabled
        ? ( index * DYNAMIC_ISLAND.animations.shell.staggerMs ) / 1000
        : 0;

    if ( !animationsEnabled ) {
        return children;
    }

    return (
        <motion.div
            animate={{
                "opacity": 1,
                "scale":   isSelected ? 1.06 : 1,
            }}
            initial={{
                "opacity": 1,
                "scale":   isSelected ? 1.06 : 0.96,
            }}
            transition={{
                ...transition,
                "delay": staggerDelay,
            }}
        >
            {children}
        </motion.div>
    );
};

export default DynamicIslandItinerarySummaryMotionLegItem;
